module.exports = __webpack_public_path__ + "img/home_rw_s_icon.e240dc0.png";